<template>
  <div class="bg-white">
    <TransferingMinimizationFilter id="sidebar-transfering-minimization-filter" @apply="paginate" />

    <div style="max-height:100vh;overflow-x: auto;" class="p-1">
      <div v-if="!isLoading && pagination">
        <b-row class="font-size-11 mt-0 bg-soft-secondary sticky-header">
          <b-col md="1" class="bg-secondary text-white sticky sticky-col-1">
            {{ $t("thirdparty.text") }}
          </b-col>
          <b-col md="1" class="bg-secondary text-white sticky sticky-col-2">
            {{ $t("receiver-group.text") }}
          </b-col>
          <b-col md="10">
            <b-row>
              <b-col md="1" class="bg-secondary text-white  sticky sticky-col-3">
                {{ $t("department.text") }}
              </b-col>
              <b-col md="11">
                <b-row>
                  <b-col md="1" class="border-left bg-secondary text-white  sticky sticky-col-4"> {{ $t("process.text") }} </b-col>
                  <b-col md="11">
                    <b-row>
                      <b-col md="3" class="border-left   bg-secondary text-white  sticky sticky-col-5">
                        {{ $t("datasource.text") }}
                      </b-col>
                      <b-col md="9">
                        <b-row>
                          <b-col md="2" class="border-left   bg-secondary text-white  sticky sticky-col-6">
                            {{ $t("data-category.text") }}
                          </b-col>
                          <b-col md="10" class="border-left">
                            <b-row>
                              <b-col md="4" class="border-left">
                                {{ $t("data.text") }}
                              </b-col>
                              <b-col md="8" class="border-left">
                                <b-row>
                                  <b-col md="9" class="border-left">
                                    {{ $t("datasubject.text") }}
                                  </b-col>
                                  <b-col md="3" class="border-left">
                                    {{ $t("transfering.method.text") }}
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <!---->

        <b-row v-for="thirdParty in pagination.docs" :key="thirdParty._id" class="topLevel">
          <b-col md="1" :id="thirdParty._id" class="sticky-col sticky-col-1">
            <div class="p-2 stickyValue">
              {{ thirdParty.name | translate }}
            </div>
          </b-col>
          <b-col md="1" :id="thirdParty._id + thirdParty.receiverGroup._id" :parent="thirdParty._id" class="sticky-col sticky-col-2">
            <div class="p-2 stickyValue">
              {{ thirdParty.receiverGroup | translate }}
            </div>
          </b-col>
          <b-col>
            <b-row v-for="department in thirdParty.departments" :key="department._id">
              <b-col md="1" :id="thirdParty._id + department._id" :parent="thirdParty._id + thirdParty.receiverGroup._id" class="sticky-col sticky-col-3">
                <div class="p-2 stickyValue">
                  {{ department.name | translate }}
                </div>
              </b-col>
              <b-col md="11">
                <b-row v-for="process in department.processes" :key="process._id">
                  <b-col md="1" :id="thirdParty._id + department._id + process._id" :parent="thirdParty._id + department._id" class="sticky-col sticky-col-4">
                    <div class="p-2 stickyValue">
                      {{ process.name | translate }}
                    </div>
                  </b-col>
                  <b-col md="11">
                    <b-row v-for="datasource in process.datasources" :key="datasource._id">
                      <b-col
                        md="3"
                        :id="thirdParty._id + department._id + process._id + datasource._id"
                        :parent="thirdParty._id + department._id + process._id"
                        class="sticky-col sticky-col-5"
                      >
                        <div class="p-2 stickyValue">
                          <b> {{ datasource.name | translate }}</b>
                          <datasource-transfer-minimization-status
                            :thirdParty="thirdParty"
                            :department="department"
                            :process="process"
                            :datasource="datasource"
                            @onSave="paginate()"
                          />
                        </div>
                      </b-col>
                      <b-col md="9">
                        <b-row v-for="category in datasource.categories" :key="category._id">
                          <b-col
                            md="2"
                            :id="thirdParty._id + department._id + process._id + datasource._id + category.combinedId"
                            level="category"
                            :datasource="thirdParty._id + department._id + process._id + datasource._id"
                            :parent="thirdParty._id + department._id + process._id + datasource._id"
                            class="sticky-col sticky-col-6"
                          >
                            <div class="p-2 stickyValue">
                              {{ category.name | translate }}
                            </div>
                          </b-col>

                          <b-col md="10">
                            <b-row v-for="data in category.datas" :key="data._id">
                              <b-col
                                md="4"
                                :id="thirdParty._id + department._id + process._id + datasource._id + category.combinedId + data._id"
                                :datasource="thirdParty._id + department._id + process._id + datasource._id"
                                :data="thirdParty._id + department._id + process._id + datasource._id + category.combinedId + data._id"
                                :parent="thirdParty._id + department._id + process._id + datasource._id + category.combinedId"
                                class="sticky-col sticky-col-6"
                              >
                                <div class="p-2 stickyValue">
                                  <b>{{ data.name | translate }}</b>
                                  <data-transfer-minimization-status :thirdParty="thirdParty" :department="department" :process="process" :data="data" @onSave="paginate()" />
                                </div>
                              </b-col>
                              <b-col md="8">
                                <b-row
                                  v-for="datasubject in data.datasubjects"
                                  :key="datasubject._id"
                                  :id="thirdParty._id + department._id + process._id + datasource._id + category.combinedId + data._id + datasubject._id"
                                  :datasource="thirdParty._id + department._id + process._id + datasource._id"
                                  :data="thirdParty._id + department._id + process._id + datasource._id + category.combinedId + data._id"
                                  :parent="thirdParty._id + department._id + process._id + datasource._id + category.combinedId + data._id"
                                  level="datasubject"
                                >
                                  <b-col md="9">
                                    <b>{{ datasubject.name | translate }}</b>

                                    <datasubject-transfer-minimization-status
                                      :thirdParty="thirdParty"
                                      :department="department"
                                      :process="process"
                                      :datasubject="datasubject"
                                      @onSave="paginate()"
                                    />
                                  </b-col>
                                  <b-col md="3" class="border">
                                    <ol style="padding:1px">
                                      <li v-for="method in datasubject.transferMethods" :key="method._id">{{ method.name | translate }}</li>
                                    </ol>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("department.no-department") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="20" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import DataCollectMinimizationStatus from "./component/data-collect-minimization-status";
import DatasourceTransferMinimizationStatus from "./component/datasource-transfer-minimization-status";
import DataTransferMinimizationStatus from "./component/data-transfer-minimization-status";
import DatasubjectTransferMinimizationStatus from "./component/datasubject-transfer-minimization-status";
import TransferingMinimizationFilter from "./component/filter/transfering-minimization-filter";

export default {
  components: {
    TransferingMinimizationFilter,
    DataCollectMinimizationStatus,
    DatasourceTransferMinimizationStatus,
    DataTransferMinimizationStatus,
    DatasubjectTransferMinimizationStatus,
  },
  data() {
    return {
      hoveredItem: null,
      request: {
        options: { page: 1, limit: 50, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    pagination() {
      return this.$store.getters["minimization/transferPagination"];
    },
    isLoading() {
      return this.$store.getters["minimization/isTransferMinimizationLoading"];
    },
    criteria() {
      return this.$store.getters["transferingMinimizationFilter/criteria"];
    },
    hasFilter() {
      return Object.keys(this.criteria).find((i) => !!this.criteria[i]);
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
  },

  mounted() {},
  methods: {
    async paginate() {
      try {
        const request = { pagination: this.request };
        if (this.hasFilter) {
          request.criteria = this.criteria;
        }

        await this.$store.dispatch("minimization/fetchTransferMinimization", request);
        this.initHover();
      } catch (error) {}
    },

    initHover() {
      const divs = document.querySelectorAll(".topLevel *");
      divs.forEach((b) => {
        b.addEventListener("mouseover", (e) => {
          document.querySelectorAll(".highlight").forEach((i) => i.classList.remove("highlight"));
          let el = e.target;
          if (!el.attributes["parent"]) {
            el = el.closest("[parent]");
          }
          if (!el) {
            return;
          }
          let parentId = el.attributes["parent"].value;

          [
            ...(el.attributes["level"]?.value == "category" ? [] : document.querySelectorAll("[datasource='" + parentId + "']")),
            ...(el.attributes["level"]?.value == "datasubject" ? [] : document.querySelectorAll("[data='" + parentId + "']")),
            ...document.querySelectorAll("[datasubject='" + parentId + "']"),
          ].forEach((i) => i.classList.add("highlight"));

          el.classList.add("highlight");
          let parent = document.querySelector("[id='" + parentId + "']");
          while (parent) {
            parent.classList.add("highlight");
            parent = document.querySelector("[id='" + parent.attributes["parent"]?.value + "']");
          }
        });
        b.addEventListener("mouseleave", (e) => {
          document.querySelectorAll(".highlight").forEach((i) => i.classList.remove("highlight"));
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.border-light {
  border: 0.01em solid rgb(144, 144, 144) !important;
}

.topLevel div {
  font-size: 10px;
}

.topLevel .row > div:nth-child(1):not(.sub-table div):not(.sub-inventory div) {
  // border: 0.01em solid rgb(221 221 221);
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;
}

.topLevel {
  border-bottom: 1px solid rgb(221 221 221);
}

.sub-table table {
  min-width: 200px;
}

.sub-table table td,
.sub-table table th {
  padding: 4px !important;
}

.sub-inventory div {
  // border: 0.01em solid rgb(234, 234, 234);
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;
}

.highlight {
  background-color: rgb(246, 251, 255) !important;
}
.highlight-dark {
  background-color: rgb(233, 246, 255) !important;
}

.sticky,
.sticky-col {
  width: 150px;
  position: sticky;
  z-index: 1;
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;

  .stickyValue {
    position: sticky;
    top: 40px;
  }

  // div {
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
}

.sticky-col {
  background-color: white;
}

.sticky-col-1 {
  left: 0px;
}

.sticky-col-2 {
  left: 70px;
}

.sticky-col-3 {
  left: 140px;
}

.sticky-col-4 {
  left: 200px;
}

.sticky-col-5 {
  left: 260px;
}

.sticky-col-6 {
  left: 400px;
}

.bg-soft-inventory {
  background-color: rgb(240, 229, 253);
}

.bg-inventory {
  background-color: rgb(228, 206, 255);
}

.bg-soft-secondary {
  background-color: rgb(222, 222, 222) !important;
}

.sticky-header {
  position: sticky;
  top: -4px;
  z-index: 2;
}

.sticky-header-fs {
  position: sticky;
  top: -4px;
  z-index: 2;
}

.col ul {
  padding-left: 15px;
  margin: 0px;
}
</style>
